import i18next from 'i18next'
import { QUICK_PAY_LIMIT } from '../constants'
import { isEmpty, isValidDate } from '../form'
import { findDuplicateFieldIndexes } from '../utils/invoice.utils'
import { formatTime } from '../utils/openForWork.utils'
import { format } from 'date-fns'

const ibantools = require('ibantools')

// Field validators
export const registerValidate = (values) => {
  const errors = {}
  const requiredFields = [
    'email',
    'FirstName',
    'Lastname',
    'password',
    'passwordConfirmation',
    'agree_to_terms'
  ]

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.kenta') // 'Kenttä on pakollinen'
    }
  })

  if (!values['password']) {
    errors.password = i18next.t('validation.sala') //'Salasanakenttä on pakollinen'
  }

  if (
    values['password'] &&
    !/^(?=^.{8,}$)(?=.*\d)(?=.*[äöåa-z])(?=.*[ÄÖÅA-Z])(?!.*\s)[0-9äöåa-zÄÖÅA-Z!@#$€£%^&*()]*$/.test(
      values['password']
    )
  ) {
    errors.password = i18next.t('validation.virhe')
    //'Virheellinen salasana, Salasanan tulee sisältää vähintään: 8 merkkiä, numeroita, pieniä ja isoja kirjaimia!'
  }

  if (values['password'] !== values['passwordConfirmation']) {
    errors.passwordConfirmation = i18next.t('validation.anta') //'Antamasi salasanat eivät täsmää'
  }

  if (!values['passwordConfirmation']) {
    errors.passwordConfirmation = i18next.t('validation.vahvis') //'Salasanan vahvistus on pakollinen'
  }

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = i18next.t('validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  if (!values['FirstName']) {
    errors.givenName = i18next.t('validation.etu') //'Etunimi on pakollinen'
  }

  if (!values['Lastname']) {
    errors.familyName = i18next.t('validation.suku') //'Sukunimi on pakollinen'
  }

  //console.log('Inside registerValidate:: ', errors)
  return { values, errors }
}

export const loginValidate = (values) => {
  const errors = {}
  const requiredFields = ['email', 'password']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.kenta') // 'Kenttä on pakollinen'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = i18next.t('validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }
  return { values, errors }
}

export const invoiceValidate = (
  values,
  registeredUsersList,
  attachedWorkShiftJournalIds
) => {
  const errors = {}

  // Customer Info
  // Kas-203,206,202
  let requiredCustomerInfoFields = [
    'company_name',
    'person_to_contact',
    'person_to_contact_email',
    'delivery_method',
    'customer_type',
    'country'
  ]

  if (
    values['country'] != '1' &&
    values['vat_selection'] === 'building_service'
  ) {
    requiredCustomerInfoFields = [
      'company_name',
      'person_to_contact',
      'person_to_contact_email',
      'delivery_method',
      'customer_type',
      'country',
      'business_id'
    ]
  }

  let requiredDeliveryMethodFields = []

  if (
    values['delivery_method'] === 'Verkkolasku' ||
    values['delivery_method'] === 'E-invoice' ||
    values['delivery_method'] === 'E-arved'
  ) {
    requiredDeliveryMethodFields = [
      'zip_code',
      'city',
      'delivery_address',
      'web_invoice',
      'finvoice_operator'
    ]
  } else if (
    values['delivery_method'] === 'Kirjeposti' ||
    values['delivery_method'] === 'Post' ||
    values['delivery_method'] === 'Postkast'
  ) {
    requiredDeliveryMethodFields = ['zip_code', 'city', 'delivery_address']
  }

  // Invoice Info
  const requiredInvoiceInfoFields = []

  const requiredFields = [
    ...requiredCustomerInfoFields,
    ...requiredDeliveryMethodFields,
    ...requiredInvoiceInfoFields
  ]

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.kenta') //'Kenttä on pakollinen'
    } else if (values[field] && /^\s*$/.test(values[field])) {
      errors[field] = i18next.t('validation.syote') // 'Syöte ei ole kelvollinen'
    }
  })

  if (isEmpty(values['customer_type'])) {
    errors['wonder'] = i18next.t('validation.kenta')
  }

  // KAS-339 If customer type is company, business_is is required
  if (isEmpty(values['business_id']) && values['customer_type'] == 'company') {
    errors['business_id'] = i18next.t('validation.kenta')
  }
  if (
    values.country == 1 &&
    !isEmpty(values['business_id']) &&
    !/^\d{7}-\d$/.test(values.business_id)
  ) {
    errors['business_id'] = i18next.t('validation.business_id')
  }

  if (
    values['zip_code'] &&
    values['country'] == 1 &&
    !/^\d{5}$/i.test(values['zip_code'])
  ) {
    errors['zip_code'] = i18next.t('validation.posti') //'Postinumero ei ole kelvollinen'
  }

  if (
    values.invoice_reference &&
    !/^[äÄöÖåÅA-Za-z0-9.\-_,\s!@#$€£%^&*()?":{}|<>]+$/i.test(
      values.invoice_reference
    )
  ) {
    errors['invoice_reference'] = i18next.t('validation.viite')
  }

  if (
    values.person_to_contact_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_contact_email
    )
  ) {
    errors['person_to_contact_email'] = i18next.t('validation.sposti')
    //'Antamasi sähköpostiosoite  on virheellinen'
  }

  if (
    values.person_to_quick_pay_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_quick_pay_email
    )
  ) {
    errors.person_to_quick_pay_email = i18next.t('validation.sposti')
    // 'Antamasi sähköpostiosoite  on virheellinen'
  }

  if (values.rows.length === 0) {
    errors.rows = 'Must contain at least one row'
  }

  var hasNegativeRow = false
  var hasPositiveRow = false

  const rowErrors = []
  values.rows.forEach((row, index) => {
    const error = {}
    if (isEmpty(row.description)) {
      error.description = i18next.t('validation.pako') //'Pakollinen'
    } else if (!!row.description && /^\s*$/.test(row.description)) {
      error.description = i18next.t('validation.syote')
      // 'Syöte ei ole kelvollinen'
    } else if (row.description && row.description.length > 100) {
      error.description = i18next.t('validation.freeText')
    }

    if (isEmpty(row.start_date.toString())) {
      error.start_date = i18next.t('validation.pako') //'Pakollinen'
    } else if (!isValidDate(row.start_date) || row.start_date > row.end_date) {
      error.start_date = i18next.t('validation.date') //'Virheellinen päivämäärä'
    }

    if (isEmpty(row.end_date.toString())) {
      error.end_date = i18next.t('validation.pako') //'Pakollinen'
    } else if (!isValidDate(row.end_date) || row.end_date < row.start_date) {
      error.end_date = i18next.t('validation.date') //'Virheellinen päivämäärä'
    }

    if (isEmpty(row.quantity)) {
      error.quantity = i18next.t('validation.pako') // 'Pakollinen'
    } else if (!/^[0-9]{1,6}([,.][0-9]{1,2})?$/i.test(row.quantity)) {
      error.quantity = i18next.t('validation.maara') // 'Virheellinen määrä'
    }
    if (isEmpty(row.unit)) {
      error.unit = i18next.t('validation.pako') //'Pakollinen'
    }
    if (isEmpty(row.quantity_price)) {
      error.quantity_price = i18next.t('validation.pako') //'Pakollinen'
    } else if (!/^[-]?[0-9]{1,6}([,.][0-9]{1,2})?$/i.test(row.quantity_price)) {
      error.quantity_price = i18next.t('validation.hinta') //'Virheellinen hinta'
    }
    if (row.sum_with_vat < 0) {
      hasNegativeRow = true
    } else hasPositiveRow = true
    if (!isEmpty(error)) {
      rowErrors[index] = error
    }

    if (values['is_credit_note'] && index === 0 && row.sum_with_vat >= 0) {
      errors.rows = 'Credit note amount cannot be positive.'
    }
  })

  if (!isEmpty(rowErrors)) {
    errors.rows = rowErrors
  }

  if (hasNegativeRow && hasPositiveRow) {
    errors.rows = 'Invoice cannot contain both positive and negative rows.'
  }

  if (hasNegativeRow && values.quick_pay) {
    errors.rows = 'Quick pay is not allowed for negative invoices.'
  }

  const totalSum = parseFloat(
    values['total_sum'].toString().replace(/\s+/g, '').replace(',', '.')
  )
  if (values.quick_pay && totalSum > QUICK_PAY_LIMIT) {
    errors.rows = 'Quick pay exceeded'
  }

  if (values.rows.length === 0) {
    errors.rows = 'Invoice must contain at least one row.'
  }

  if (values.groupInvoice) {
    const groupInvoiceRowErrors = []
    let duplicatedEmails = findDuplicateFieldIndexes(
      values.groupInvoiceRow,
      'groupEmail'
    )
    values.groupInvoiceRow.forEach((row, index) => {
      const error = {}
      if (duplicatedEmails.includes(index)) {
        error.groupEmail = i18next.t('validation.duplicateEmail')
      }
      if (!isEmpty(row.groupEmail)) {
        if (
          !registeredUsersList.some((item) => item.email === row.groupEmail)
        ) {
          error.groupEmail = i18next.t('validation.verifyEmail')
        }
      }
      if (isEmpty(row.groupEmail)) {
        error.groupEmail = i18next.t('validation.pako') //'Pakollinen'
      }
      if (!isEmpty(row.groupAmount) && row.groupAmount <= 0) {
        error.groupAmount = i18next.t('validation.hinta')
      }
      if (
        values.groupTotalAmount !== undefined &&
        values.groupTotalAmount !== null &&
        parseFloat(values.groupTotalAmount) > 0
      ) {
        if (isEmpty(row.groupEmail)) {
          error.groupEmail = i18next.t('validation.pako') //'Pakollinen'
        }
        if (isEmpty(row.groupAmount) || row.groupAmount == 0) {
          error.groupAmount = i18next.t('validation.pako') //'Pakollinen'
        }
      }

      if (!isEmpty(error)) {
        groupInvoiceRowErrors[index] = error
      }
    })

    if (!isEmpty(groupInvoiceRowErrors)) {
      errors.groupInvoiceRow = groupInvoiceRowErrors
    }

    if (
      values.groupTotalAmount !== undefined &&
      values.groupTotalAmount !== null &&
      parseFloat(values.groupTotalAmount) > 0
    ) {
      if (parseFloat(values.groupTotalAmount) < parseFloat(values.total_sum)) {
        errors['groupTotalAmount'] = i18next.t(
          'validation.groupTotalAmountLimitNotReached'
        )
      } else if (
        parseFloat(values.groupTotalAmount) > parseFloat(values.total_sum)
      ) {
        errors['groupTotalAmount'] = i18next.t(
          'validation.groupTotalAmountLimitExceeds'
        )
      }
    }

    if (parseFloat(values.groupTotalAmount) <= 0) {
      errors['groupTotalAmount'] = i18next.t(
        'validation.groupTotalAmountLimitNotReached'
      )
    }

    if (values.addWorkshiftJournal) {
      if (attachedWorkShiftJournalIds.length <= 0) {
        errors.attachedJournal = 'Select work shift journal'
      }
    }
  }
  return { values, errors }
}

export const invoiceCustomerInfoValidate = (values) => {
  const errors = {}

  const requiredFields = [
    'company_name',
    'person_to_contact',
    'person_to_contact_email',
    'delivery_method',
    'customer_type',
    'country'
  ]

  if (
    values['country'] != '1' &&
    values['vat_selection'] === 'building_service'
  ) {
    requiredFields.push('business_id')
  }

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.kenta')
    } else if (/^\s*$/.test(values[field])) {
      errors[field] = i18next.t('validation.syote')
    }
  })

  if (isEmpty(values['business_id']) && values['customer_type'] == 'company') {
    errors['business_id'] = i18next.t('validation.pako')
  }

  if (
    values.country == 1 &&
    !isEmpty(values['business_id']) &&
    !/^\d{7}-\d$/.test(values.business_id)
  ) {
    errors['business_id'] = i18next.t('validation.business_id')
  }

  if (values['customer_type'] === 'company' && isEmpty(values['business_id'])) {
    errors['business_id'] = i18next.t('validation.kenta')
  }

  if (
    values.person_to_contact_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_contact_email
    )
  ) {
    errors.person_to_contact_email = i18next.t('validation.sposti')
    // 'Antamasi sähköpostiosoite  on virheellinen'
  }
  if (
    values.person_to_quick_pay_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_quick_pay_email
    )
  ) {
    errors.person_to_quick_pay_email = i18next.t('validation.sposti')
    // 'Antamasi sähköpostiosoite  on virheellinen'
  }

  return { values, errors }
}

export const invoiceDeliveryAndDetailsValidate = (values) => {
  const errors = {}

  let requiredCustomerInfoFields = ['delivery_method']

  let requiredDeliveryMethodFields = []

  if (
    values['delivery_method'] === 'Verkkolasku' ||
    values['delivery_method'] === 'E-invoice' ||
    values['delivery_method'] === 'E-arved'
  ) {
    requiredDeliveryMethodFields = [
      'zip_code',
      'city',
      'delivery_address',
      'web_invoice',
      'finvoice_operator'
    ]
  } else if (
    values['delivery_method'] === 'Kirjeposti' ||
    values['delivery_method'] === 'Post' ||
    values['delivery_method'] === 'Postkast'
  ) {
    requiredDeliveryMethodFields = ['zip_code', 'city', 'delivery_address']
  }

  const requiredFields = [
    ...requiredCustomerInfoFields,
    ...requiredDeliveryMethodFields
  ]

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.kenta') //'Kenttä on pakollinen'
    } else if (values[field] && /^\s*$/.test(values[field])) {
      errors[field] = i18next.t('validation.syote') // 'Syöte ei ole kelvollinen'
    }
  })

  if (
    values['zip_code'] &&
    values['country'] == 1 &&
    !/^\d{5}$/i.test(values['zip_code'])
  ) {
    errors['zip_code'] = i18next.t('validation.posti') //'Postinumero ei ole kelvollinen'
  }

  if (
    values.invoice_reference &&
    !/^[äÄöÖåÅA-Za-z0-9.\-_,\s!@#$€£%^&*()?":{}|<>]+$/i.test(
      values.invoice_reference
    )
  ) {
    errors['invoice_reference'] = i18next.t('validation.viite')
  }

  return { values, errors }
}

export const invoiceProductsAndServicesValidate = (
  values,
  registeredUsersList,
  attachedWorkShiftJournalIds
) => {
  const errors = {}

  if (values.rows.length === 0) {
    errors.rows = 'Must contain at least one row'
  }

  var hasNegativeRow = false
  var hasPositiveRow = false

  const rowErrors = []
  values.rows.forEach((row, index) => {
    const error = {}
    if (isEmpty(row.description)) {
      error.description = i18next.t('validation.pako') //'Pakollinen'
    } else if (!!row.description && /^\s*$/.test(row.description)) {
      error.description = i18next.t('validation.syote')
      // 'Syöte ei ole kelvollinen'
    } else if (row.description && row.description.length > 100) {
      error.description = i18next.t('validation.freeText')
    }

    if (isEmpty(row.start_date.toString())) {
      error.start_date = i18next.t('validation.pako') //'Pakollinen'
    } else if (!isValidDate(row.start_date) || row.start_date > row.end_date) {
      error.start_date = i18next.t('validation.date') //'Virheellinen päivämäärä'
    }

    if (isEmpty(row.end_date.toString())) {
      error.end_date = i18next.t('validation.pako') //'Pakollinen'
    } else if (!isValidDate(row.end_date) || row.end_date < row.start_date) {
      error.end_date = i18next.t('validation.date') //'Virheellinen päivämäärä'
    }

    if (isEmpty(row.quantity)) {
      error.quantity = i18next.t('validation.pako') // 'Pakollinen'
    } else if (!/^[0-9]{1,6}([,.][0-9]{1,2})?$/i.test(row.quantity)) {
      error.quantity = i18next.t('validation.maara') // 'Virheellinen määrä'
    }
    if (isEmpty(row.unit)) {
      error.unit = i18next.t('validation.pako') //'Pakollinen'
    }
    if (isEmpty(row.quantity_price)) {
      error.quantity_price = i18next.t('validation.pako') //'Pakollinen'
    } else if (!/^[-]?[0-9]{1,6}([,.][0-9]{1,2})?$/i.test(row.quantity_price)) {
      error.quantity_price = i18next.t('validation.hinta') //'Virheellinen hinta'
    }
    if (row.sum_with_vat < 0) {
      hasNegativeRow = true
    } else hasPositiveRow = true
    if (!isEmpty(error)) {
      rowErrors[index] = error
    }

    if (values['is_credit_note'] && index === 0 && row.sum_with_vat >= 0) {
      errors.rows = 'Credit note amount cannot be positive.'
    }
  })

  if (!isEmpty(rowErrors)) {
    errors.rows = rowErrors
  }

  if (hasNegativeRow && hasPositiveRow) {
    errors.rows = 'Invoice cannot contain both positive and negative rows.'
  }

  if (hasNegativeRow && values.quick_pay) {
    errors.rows = 'Quick pay is not allowed for negative invoices.'
  }

  const totalSum = parseFloat(
    values['total_sum'].toString().replace(/\s+/g, '').replace(',', '.')
  )
  if (values.quick_pay && totalSum > QUICK_PAY_LIMIT) {
    errors.rows = 'Quick pay exceeded'
  }

  if (values.rows.length === 0) {
    errors.rows = 'Invoice must contain at least one row.'
  }

  if (values.groupInvoice) {
    const groupInvoiceRowErrors = []
    let duplicatedEmails = findDuplicateFieldIndexes(
      values.groupInvoiceRow,
      'groupEmail'
    )
    values.groupInvoiceRow.forEach((row, index) => {
      const error = {}
      if (duplicatedEmails.includes(index)) {
        error.groupEmail = i18next.t('validation.duplicateEmail')
      }
      if (!isEmpty(row.groupEmail)) {
        if (
          !registeredUsersList.some((item) => item.email === row.groupEmail)
        ) {
          error.groupEmail = i18next.t('validation.verifyEmail')
        }
      }
      if (isEmpty(row.groupEmail)) {
        error.groupEmail = i18next.t('validation.pako') //'Pakollinen'
      }
      if (!isEmpty(row.groupAmount) && row.groupAmount <= 0) {
        error.groupAmount = i18next.t('validation.hinta')
      }
      if (
        values.groupTotalAmount !== undefined &&
        values.groupTotalAmount !== null &&
        parseFloat(values.groupTotalAmount) > 0
      ) {
        if (isEmpty(row.groupEmail)) {
          error.groupEmail = i18next.t('validation.pako') //'Pakollinen'
        }
        if (isEmpty(row.groupAmount) || row.groupAmount == 0) {
          error.groupAmount = i18next.t('validation.pako') //'Pakollinen'
        }
      }

      if (!isEmpty(error)) {
        groupInvoiceRowErrors[index] = error
      }
    })

    if (!isEmpty(groupInvoiceRowErrors)) {
      errors.groupInvoiceRow = groupInvoiceRowErrors
    }

    if (
      values.groupTotalAmount !== undefined &&
      values.groupTotalAmount !== null &&
      parseFloat(values.groupTotalAmount) > 0
    ) {
      if (parseFloat(values.groupTotalAmount) < parseFloat(values.total_sum)) {
        errors['groupTotalAmount'] = i18next.t(
          'validation.groupTotalAmountLimitNotReached'
        )
      } else if (
        parseFloat(values.groupTotalAmount) > parseFloat(values.total_sum)
      ) {
        errors['groupTotalAmount'] = i18next.t(
          'validation.groupTotalAmountLimitExceeds'
        )
      }
    }

    if (parseFloat(values.groupTotalAmount) <= 0) {
      errors['groupTotalAmount'] = i18next.t(
        'validation.groupTotalAmountLimitNotReached'
      )
    }
  }

  if (values.addWorkshiftJournal) {
    if (attachedWorkShiftJournalIds.length <= 0) {
      errors.attachedJournal = 'Select work shift journal'
    }
  }

  return { values, errors }
}

export const customerValidate = (values) => {
  const errors = {}

  const requiredFields = [
    'company_name',
    'person_to_contact',
    'person_to_contact_email',
    'customer_type',
    'country'
  ]
  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (values['company_name'] && /^\s*$/.test(values['company_name'])) {
    errors['company_name'] = i18next.t('validation.syote')
    // 'Syöte ei ole kelvollinen'
  }

  // KAS-339 If customer type is company, business_is is required
  if (isEmpty(values['business_id']) && values['customer_type'] == 'company') {
    errors['business_id'] = i18next.t('validation.pako')
  }
  if (
    values.country == 1 &&
    !isEmpty(values['business_id']) &&
    !/^\d{7}-\d$/.test(values.business_id)
  ) {
    errors['business_id'] = i18next.t('validation.business_id')
  }

  if (
    values['person_to_contact'] &&
    /^\s*$/.test(values['person_to_contact'])
  ) {
    errors['person_to_contact'] = i18next.t('validation.syote')
    // 'Syöte ei ole kelvollinen'
  }

  if (
    values['zip_code'] &&
    values['country'] == 1 &&
    !/^\d{5}$/i.test(values['zip_code'])
  ) {
    errors['zip_code'] = i18next.t('validation.posti') // 'Postinumero ei ole kelvollinen'
  }

  if (
    values.person_to_contact_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_contact_email
    )
  ) {
    errors.person_to_contact_email = i18next.t('validation.sposti')
    // 'Antamasi sähköpostiosoite  on virheellinen'
  }
  if (
    values.person_to_quick_pay_email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      values.person_to_quick_pay_email
    )
  ) {
    errors.person_to_quick_pay_email = i18next.t('validation.sposti')
    // 'Antamasi sähköpostiosoite  on virheellinen'
  }

  //console.log('errors:: ', errors)
  return { values, errors }
}

export const profileValidate = (values) => {
  const errors = {}
  const requiredFields = [
    'lastname',
    'firstname',
    'address',
    'phone',
    'city',
    'account_number',
    'ssn'
    // KAS-338 Marketing name is not mandatory
  ]

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  // KAS-342 if useMarketName is true, market_name is required
  if (isEmpty(values['market_name']) && values['useMarketName'] === true) {
    errors['market_name'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
  }

  if (!/^\d{5}$/i.test(values['zip_code']) || !values['zip_code']) {
    errors['zip_code'] = i18next.t('validation.posti') // 'Postinumero ei ole kelvollinen'
  }

  const iban = ibantools.electronicFormatIBAN(values['account_number'])

  if (!ibantools.isValidIBAN(iban)) {
    errors['account_number'] = i18next.t('validation.tilinumero') // 'Tilinumero ei ole voimassa'
  }

  if (values['ssn']) {
    let isCorrectFormat = validateSSN(values['ssn'])

    if (!isCorrectFormat) {
      errors['ssn'] = i18next.t('validation.ssn')
    }
  }

  return { values, errors }
}

export const changeUserEmailValidate = (values, emailLoggedIn) => {
  const errors = {}
  const requiredFields = ['new_email']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    (values.new_email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.new_email)) ||
    values.new_email === emailLoggedIn
  ) {
    errors.new_email = i18next.t('validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  return { values, errors }
}

export const adminCustomerValidate = (values) => {
  const errors = {}
  let requiredFields = [
    'lastname',
    'firstname',
    'address',
    'phone',
    'city',
    'account_number',
    'ssn'
    // Marketing name is not mandatory
  ]

  if (values['taxCard_number'] !== '') {
    requiredFields = [
      'lastname',
      'firstname',
      'address',
      'phone',
      'city',
      'account_number',
      'ssn',
      'taxCard_number',
      'taxCard_zip_code',
      'taxCard_address',
      'taxCard_city'
    ]
    if (values['construction'] === false && values['shipbuilding'] === false) {
      errors['construction'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  }

  if (
    values['isgovpay'] ||
    values['ismanualgovpay'] ||
    values['isbruttogovpay'] ||
    values['isnormalgovpay']
  ) {
    requiredFields = [...requiredFields, 'withdrawal_account_number']
  }

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })
  if (!/^\d{5}$/i.test(values['zip_code']) || !values['zip_code']) {
    errors['zip_code'] = i18next.t('validation.posti') // 'Postinumero ei ole kelvollinen'
  }

  // KAS-427 if useMarketName is true, market_name is required
  if (isEmpty(values['market_name']) && values['useMarketName'] === true) {
    errors['market_name'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
  }

  const iban = ibantools.electronicFormatIBAN(values['account_number'])

  if (!ibantools.isValidIBAN(iban)) {
    errors['account_number'] = i18next.t('validation.tilinumero') // 'Tilinumero ei ole voimassa'
  }

  if (values['ssn']) {
    let isCorrectFormat = validateSSN(values['ssn'])

    if (!isCorrectFormat) {
      errors['ssn'] = i18next.t('validation.ssn')
    }
  }

  if (values['ismanualgovpay'] && values['maxmonthlygovpay'] <= 0) {
    errors['maxmonthlygovpay'] =
      'Ulosotto vaatii summan, joka on suurempi kuin 0'
  }

  const isgovpay_iban = ibantools.electronicFormatIBAN(
    values['withdrawal_account_number']
  )

  if (
    values['withdrawal_account_number'] &&
    !ibantools.isValidIBAN(isgovpay_iban)
  ) {
    errors['withdrawal_account_number'] = i18next.t('validation.tilinumero') // 'Tilinumero ei ole voimassa'
  }

  const spaceSeparatedPattern =
    /^([äÄöÖåÅA-Za-z0-9.\-_,!@#$€£%^&*()?":{}|<>]{4} ?)*[äÄöÖåÅA-Za-z0-9.\-_,!@#$€£%^&*()?":{}|<>]+$/

  if (
    values.withdrawal_reference_number &&
    !spaceSeparatedPattern.test(values.withdrawal_reference_number)
  ) {
    errors['withdrawal_reference_number'] = i18next.t('validation.viite')
  }

  if (
    values.tax_card &&
    !/^[äÄöÖåÅA-Za-z0-9.\-_,!@#$€£%^&*()?":{}|<>]+$/i.test(values.tax_card)
  ) {
    errors['tax_card'] = i18next.t('validation.taxcard')
  }

  if (
    values.payment_ban_number &&
    !/^[äÄöÖåÅA-Za-z0-9.\-_,!@#$€£%^&*()?":{}|<>]+$/i.test(
      values.payment_ban_number
    )
  ) {
    errors['payment_ban_number'] = i18next.t('validation.payment_ban_number')
  }

  return { values, errors }
}

export const validateSSN = (ssn) => {
  let isCorrectFormat = /^\d{6}[-A][0-9A-Z]{4}$/.test(ssn)

  if (isCorrectFormat) {
    let day = parseInt(ssn.substring(0, 2))
    let month = parseInt(ssn.substring(2, 4))
    let year = parseInt(ssn.substring(4, 6))
    if (ssn.charAt(6) === '-') year += 1900
    else if (ssn.charAt(6) === 'A') year += 2000
    else isCorrectFormat = false
    let dateOfBirth = new Date(year, month - 1, day)
    let now = new Date(Date.now())
    if (
      dateOfBirth.getFullYear() !== year ||
      dateOfBirth.getMonth() + 1 !== month ||
      dateOfBirth.getDate() !== day ||
      dateOfBirth >= now
    ) {
      isCorrectFormat = false
    }
    let individualNumber = parseInt(ssn.substring(7, 10))
    if (individualNumber < 2 || individualNumber > 999) isCorrectFormat = false
    let controlCharacter = ssn.charAt(10)
    let controlArray = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'H',
      'J',
      'K',
      'L',
      'M',
      'N',
      'P',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y'
    ]
    let remainder =
      parseInt(
        ssn.substring(0, 2) +
          ssn.substring(2, 4) +
          ssn.substring(4, 6) +
          ssn.substring(7, 10)
      ) % 31
    if (
      remainder >= controlArray.length ||
      controlCharacter !== controlArray[remainder]
    )
      isCorrectFormat = false
  }
  return isCorrectFormat
}

export const expenseValidate = (values) => {
  const errors = {}
  const requiredFields = [
    //'invoice',
    'place_of_purchase',
    'date_of_purchase',
    'receipt_picture'
  ]

  requiredFields.forEach((field) => {
    if (isEmpty(values?.[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  const rowErrors = []
  values.expenseInputRow.forEach((item, index) => {
    if (!isEmpty(item)) {
      const error = {}
      if (isEmpty(item.description)) {
        error.description = i18next.t('validation.pako') //'Pakollinen kenttä'
      }
      if (item.description && /^\s*$/.test(item.description)) {
        error.description = i18next.t('validation.syote')
        // 'Syöte ei ole kelvollinen'
      }
      if (!/^[0-9]{1,6}([,.][0-9]{1,2})?$/i.test(item.sum)) {
        error.sum = i18next.t('validation.summa') // 'Summa ei ole kelvollinen'
      }
      if (isEmpty(item.sum)) {
        error.sum = i18next.t('validation.pako') // 'Pakollinen kenttä'
      }
      if (isEmpty(item.vat)) {
        error.vat = i18next.t('validation.pako') // 'Pakollinen kenttä'
      }
      if (isEmpty(item.cost_type)) {
        error.cost_type = i18next.t('validation.pako')
      }
      if (!isEmpty(error)) {
        rowErrors[index] = error
      }
    }
  })

  if (!isEmpty(rowErrors)) {
    errors.expenseInputRow = rowErrors
  }

  if (!values['consent']) {
    errors['consent'] = i18next.t('validation.kenta')
  }

  if (
    values['place_of_purchase'] &&
    /^\s*$/.test(values['place_of_purchase'])
  ) {
    errors['place_of_purchase'] = i18next.t('validation.syote')
    // 'Syöte ei ole kelvollinen'
  }

  //console.log('Inside expenseValidateErrors:: ', errors)
  return { values, errors }
}

export const allowanceValidate = (values) => {
  const errors = {}
  const requiredFields = [
    //'invoice',
    'destination',
    'country',
    'start_date',
    'start_time',
    'end_date',
    'end_time',
    // 'allowanceInputRow'
    'startPlace',
    'endPlace'
  ]
  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }
  })

  if (values.mileage_allowance) {
    const requiredMileageFields = ['distance', 'license_plate', 'vehicle_type']

    if (
      !values[requiredMileageFields[0]] ||
      !/^(\d+)((\d+)|((,\d+)?))+(\.\d+)?$/.test(
        values[requiredMileageFields[0]]
      )
    ) {
      errors[requiredMileageFields[0]] = i18next.t('validation.syote') // 'Syöte ei ole kelvollinen'
    }

    if (
      values.decisionSelect === 'add_to_payroll' &&
      values[requiredMileageFields[0]] &&
      values[requiredMileageFields[0]] < 15
    ) {
      errors[requiredMileageFields[0]] = i18next.t('validation.minDistance') // 'Minimum 15km'
    }

    if (
      values[requiredMileageFields[2]] !== 'bicycle' &&
      !values[requiredMileageFields[1]]
    ) {
      errors[requiredMileageFields[1]] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }

    if (values[requiredMileageFields[2]] === 'Valitse') {
      errors[requiredMileageFields[2]] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  }

  const routeStartArrayErrors = []
  if (values.startPlace)
    for (let index in values.startPlace) {
      const routeErrors = {}
      if (isEmpty(values.startPlace[index].route)) {
        routeErrors.route = i18next.t('validation.pako') //'Kenttä on pakollinen'
        routeStartArrayErrors[index] = routeErrors
      }
    }
  if (!isEmpty(routeStartArrayErrors)) {
    errors.startPlace = routeStartArrayErrors
  }

  const routeEndErrors = []
  if (values.endPlace)
    for (let index in values.endPlace) {
      const routeErrors = {}
      if (isEmpty(values.endPlace[index].route)) {
        routeErrors.route = i18next.t('validation.pako') //'Kenttä on pakollinen'
        routeEndErrors[index] = routeErrors
      }
    }
  if (!isEmpty(routeEndErrors)) {
    errors.endPlace = routeEndErrors
  }
  // routeArrayErrors.filter(_ => !!_.route).length !== 0 &&
  //   (errors.allowanceInputRow = routeArrayErrors)

  //allowancePassenger
  const passengerArrayErrors = []
  if (values.allowancePassenger)
    for (let index in values.allowancePassenger) {
      const passengerErrors = {}
      if (isEmpty(values.allowancePassenger[index].passenger)) {
        passengerErrors.passenger = i18next.t('validation.lisa') //'Lisää matkustajan nimi, tai poista rivi'
        passengerArrayErrors[index] = passengerErrors
      }
    }
  if (!isEmpty(passengerArrayErrors)) {
    errors.allowancePassenger = passengerArrayErrors
  }
  // passengerArrayErrors.filter(_ => !!_.passenger).length !== 0 &&
  //   (errors.allowancePassenger = passengerArrayErrors)

  //console.log('Inside allowanceValidateErrors:: ', errors)
  if (!values['consent']) {
    errors['consent'] = i18next.t('validation.kenta')
  }

  if (values['destination'] && /^\s*$/.test(values['destination'])) {
    errors['destination'] = i18next.t('validation.syote')
    // 'Syöte ei ole kelvollinen'
  }

  if (
    values.mileage_allowance &&
    values.vehicle_type === 'default_vehicle_type'
  ) {
    errors.vehicle_type = i18next.t('validation.vehicle')
  }

  return { values, errors }
}

export const yelValidate = (values) => {
  const errors = {}
  const requiredFields = ['yel_income', 'age_group']

  requiredFields.forEach((field) => {
    if (
      isEmpty(values[field]) &&
      (values.yelSelect === 'yel_recommended' ||
        values.yelSelect === 'yel_minimum')
    ) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    values['yel_income'] &&
    !/^[0-9 ]{1,}([,.][0-9]{1,2})?$/i.test(values['yel_income'])
  ) {
    errors['yel_income'] = i18next.t('validation.maara')
  }

  return { values, errors }
}

export const decisionDialogValidate = (values) => {
  const errors = {}
  const requiredFields = ['decisionSelect', 'invoice_group']

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }
  })

  //console.log('Inside decisionDialogValidateErrors:: ', errors)
  return { values, errors }
}

export const passwordValidate = (values) => {
  const errors = {}
  const requiredFields = ['current_pw', 'new_pw', 'check_pw']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }
  })

  if (
    values.new_pw &&
    !/^(?=^.{8,}$)(?=.*\d)(?=.*[äöåa-z])(?=.*[ÄÖÅA-Z])(?!.*\s)[0-9äöåa-zÄÖÅA-Z!@#$€£%^&*()]*$/.test(
      values['new_pw']
    )
  ) {
    errors.new_pw = i18next.t('validation.virhe2') // 'Virheellinen salasana, noudata ohjeita!'
  }

  if (values['new_pw'] !== values['check_pw']) {
    errors.check_pw = i18next.t('validation.anta') //'Antamasi salasanat eivät täsmää'
  }

  return { values, errors }
}

export const resetPasswordValidate = (values) => {
  const errors = {}
  const requiredFields = ['email']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = i18next.t('validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  return { values, errors }
}

export const adminValidate = (values) => {
  const errors = {}
  const requiredFields = ['start_date', 'end_date']

  requiredFields.forEach((field) => {
    if (!isValidDate(values[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  return { values, errors }
}

export const openForWorkValidate = (values) => {
  const errors = {}
  const requiredFields = [
    'AreaOf_Expertise',
    'AreaOf_Work',
    'short_des'
    // 'letter_file',
    // 'CV_file'
  ]

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
    if (values['AreaOf_Expertise'].length === 0) {
      errors['AreaOf_Expertise'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
    if (values['AreaOf_Work'].length === 0) {
      errors['AreaOf_Work'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  const rowErrors = []
  values.experienceInputRow.forEach((item, index) => {
    if (!isEmpty(item)) {
      if (
        item.CompanyName !== '' ||
        item.Location !== '' ||
        item.JobTitle !== '' ||
        item.Responsibilities !== '' ||
        item.KeyAchievements !== '' ||
        item.start_month !== 0 ||
        item.start_year !== 0 ||
        item.end_month !== 0 ||
        item.end_year !== 0
      ) {
        const error = {}
        if (item.end_year < item.start_year) {
          error.end_year = i18next.t('validation.endYear') //'End year is not valid'
        }
        if (item.start_year == item.end_year) {
          if (item.end_month < item.start_month) {
            error.end_month = i18next.t('validation.endMonth') //'End month is not valid'
          }
        }
        if (item.start_month === 0) {
          error.start_month = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (item.start_year === 0) {
          error.start_year = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (item.end_month === 0) {
          error.end_month = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (item.end_year === 0) {
          error.end_year = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (isEmpty(item.CompanyName)) {
          error.CompanyName = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (isEmpty(item.Location)) {
          error.Location = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (isEmpty(item.JobTitle)) {
          error.JobTitle = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        if (isEmpty(item.Responsibilities)) {
          error.Responsibilities = i18next.t('validation.pako') //'Kenttä on pakollinen'
        }
        // if (isEmpty(item.KeyAchievements)) {
        //   error.KeyAchievements = i18next.t('validation.pako') //'Kenttä on pakollinen'
        // }
        if (!isEmpty(error)) {
          rowErrors[index] = error
        }
      }
    }
  })
  if (!isEmpty(rowErrors)) {
    errors.experienceInputRow = rowErrors
  }

  // if (values.experienceInputRow.length === 0) {
  //   errors.experienceInputRow =
  //     'Open for work must contain at list one experience'
  // }

  const linkRowErrors = []
  values.linkRow.forEach((item, index) => {
    const error = {}
    if (isEmpty(item.link_title)) {
      error.link_title = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
    if (isEmpty(item.link_url)) {
      error.link_url = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }

    if (!isEmpty(error)) {
      linkRowErrors[index] = error
    }
  })

  if (!isEmpty(linkRowErrors)) {
    errors.linkRow = linkRowErrors
  }

  return { values, errors }
}

// admin invoice expand row form validation
export const adminInvoiceFormValidate = (values, isManualMaksettu) => {
  const errors = {}
  let requireFields = []
  let invoiceStatus = values.status
  let qpInvoice = values.instant_payment

  if (
    (invoiceStatus !== 1 && // Sent
      invoiceStatus !== 13 && // Modified
      invoiceStatus !== 7 && // Indistinct (old case)
      invoiceStatus !== 21 && // Admin draft
      invoiceStatus !== 22) || // Modified Draft
    isManualMaksettu
  ) {
    requireFields = ['notes']
  } else {
    requireFields = ['partial_amount_received']
  }

  requireFields.forEach((field) => {
    if (!values[field]?.toString()) {
      errors[field] = i18next.t('validation.kenta') // 'Kenttä on pakollinen'
    }
  })

  // Korko validation, due date needed change to calculate interest
  let compareDueDate

  if (values?.ReminderSent === 1) {
    compareDueDate = new Date(values?.reminder_due_date)
  } else {
    compareDueDate = new Date(values?.due_date)
  }

  let formValueDate = new Date(values['due_date_field'])

  if (
    formValueDate <= compareDueDate &&
    values['interest_fee'] === true &&
    values['send_new_invoice'] === true
  ) {
    errors.due_date_field = 'Päivitä päivät koron laskemiseksi'
  }

  if (
    !/^[0-9]{1,9}([,.][0-9]{1,2})?$/i.test(values['partial_amount_received']) &&
    values['partial_amount_received']
  ) {
    errors['partial_amount_received'] = i18next.t('validation.hinta')
  }

  if (values['due_date_fee'] === true && values['send_new_invoice'] !== true) {
    errors.send_new_invoice = 'Lähetä uusi laskukenttä on pakollinen'
  }

  if (
    values['partial_pay_fee'] === true &&
    values['send_new_invoice'] !== true
  ) {
    errors.send_new_invoice = 'Lähetä uusi laskukenttä on pakollinen'
  }

  if (values['interest_fee'] === true && values['send_new_invoice'] !== true) {
    errors.send_new_invoice = 'Lähetä uusi laskukenttä on pakollinen'
  }

  let totalSum
  if (values.ReminderSent === 1) {
    totalSum = values.total_sum + values.reminderfee + values.interestfee
  } else {
    totalSum = values.total_sum
  }

  let partial_amount_received = parseFloat(
    values['partial_amount_received']
      .toString()
      .replace(/,/g, '.')
      .replace(/\s/g, '')
  )
  let left_sum = parseFloat(
    values['left_sum'].toString().replace(/,/g, '.').replace(/\s/g, '')
  )
  if (
    invoiceStatus === 1 ||
    invoiceStatus === 13 ||
    (invoiceStatus === 7 && qpInvoice !== 'quick_pay')
  ) {
    if (
      partial_amount_received > 0 &&
      values['send_new_invoice'] !== true &&
      left_sum > 0
    ) {
      errors.send_new_invoice = 'Lähetä uusi laskukenttä on pakollinen'
    }
    if (partial_amount_received > totalSum) {
      errors.partial_amount_received = i18next.t('validation.hinta')
    }
  }

  if (values['due_date_fee'] != true && values['interest_fee'] != true) {
    if (partial_amount_received == 0 && values['send_new_invoice'] === true) {
      errors.send_new_invoice =
        'Uusi lasku -kenttä on poistettava, jos summaa ei ole maksettu'
    }
  }

  if (partial_amount_received == 0 && values['partial_pay_fee'] === true) {
    errors.partial_amount_received = i18next.t('validation.hinta')
  }

  if (qpInvoice === 'quick_pay' && invoiceStatus === 7) {
    if (
      partial_amount_received > 0 &&
      values['send_qp_admin_invoice'] !== true &&
      left_sum > 0
    ) {
      errors.send_qp_admin_invoice = 'Lähetä admin laskukenttä on pakollinen'
    }
    if (partial_amount_received > totalSum) {
      errors.partial_amount_received = i18next.t('validation.hinta')
    }
  }

  return { values, errors }
}

export const taxValidate = (values) => {
  const errors = {}

  if (values?.startingBalance < 0) {
    errors.startingBalance = i18next.t('taxComponent.negative')
  }
  return { values, errors }
}

export const industryTaxCardValidate = (values) => {
  const errors = {}
  const requiredFields = [
    'lastname',
    'firstname',
    'phone',
    'ssn',
    'tax_num',
    'address',
    'zip_code',
    'city'
  ]

  requiredFields.forEach((field) => {
    if (isEmpty(values?.[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (/[a-zA-Z]/g.test(values['phone'])) {
    errors.phone = i18next.t('validation.syote') //'Input is not valid'
  }
  if (!/^\d{5}$/i.test(values['zip_code']) && values['zip_code']) {
    errors['zip_code'] = i18next.t('validation.posti') // 'Postinumero ei ole kelvollinen'
  }

  if (values['construction'] === false && values['shipbuilding'] === false) {
    errors['construction'] = i18next.t('validation.pako') //'Kenttä on pakollinen'
  }

  return { values, errors }
}

// KAS-336 Validation for send referral email program
export const referralProgramValidate = (values) => {
  const errors = {}
  const requiredFields = ['email']

  requiredFields.forEach((field) => {
    if (isEmpty(values?.[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = i18next.t('validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  return { values, errors }
}
// KAS-336 Validation for send referral code program
export const sendReferralCodeValidate = (values) => {
  const errors = {}
  const requiredFields = ['referralCode']

  requiredFields.forEach((field) => {
    if (isEmpty(values?.[field])) {
      errors[field] = i18next.t('validation.pako') //'Kenttä on pakollinen'
    }
  })

  return { values, errors }
}

// admin salary expand row form validation
export const adminSalaryFormValidate = (
  values,
  currentMonthSumUlosotto,
  maxMonthlyGovPay,
  isManualGovPay
) => {
  const errors = {}
  let requireFields = [
    isManualGovPay ? 'manual_sum_govpay_update' : 'ulosotto_sum_govpay_update'
  ]

  requireFields.forEach((field) => {
    if (!values[field]?.toString()) {
      errors[field] = i18next.t('validation.kenta') // 'Kenttä on pakollinen'
    }
  })

  if (
    isManualGovPay &&
    values['manual_sum_govpay_update'] &&
    !/^[0-9]{1,9}([,.][0-9]{1,2})?$/i.test(values['manual_sum_govpay_update'])
  ) {
    errors['manual_sum_govpay_update'] = i18next.t('validation.hinta')
  }

  if (
    !isManualGovPay &&
    values['ulosotto_sum_govpay_update'] &&
    !/^[0-9]{1,9}([,.][0-9]{1,2})?$/i.test(values['ulosotto_sum_govpay_update'])
  ) {
    errors['ulosotto_sum_govpay_update'] = i18next.t('validation.hinta')
  }

  let take_home_pay_update
  take_home_pay_update = values.take_home_pay_update

  if (take_home_pay_update <= 0) {
    if (isManualGovPay) {
      errors.manual_sum_govpay_update = i18next.t('validation.hinta')
    } else {
      errors.ulosotto_sum_govpay_update = i18next.t('validation.hinta')
    }
  }

  if (isManualGovPay && maxMonthlyGovPay === 0) {
    errors.manual_sum_govpay_update =
      'Kuukausittainen ulosoton maksimi ei voi olla 0, päivitä se käyttäjäpaneelissa'
  }

  if (isManualGovPay && maxMonthlyGovPay > 0 && currentMonthSumUlosotto >= 0) {
    const isTotalUlosottoAboveLimit =
      parseFloat(values['manual_sum_govpay_update']) + currentMonthSumUlosotto >
      maxMonthlyGovPay

    if (isTotalUlosottoAboveLimit) {
      errors.manual_sum_govpay_update =
        'Ulosoton enimmäismäärä ylittää kuukausittaisen rajan.'
    }
  }

  return { values, errors }
}

export const removeInvoiceFeeFormValidate = (values) => {
  const errors = {}
  const requiredFields = ['notes']

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }
  })

  return { values, errors }
}

export function toMinutes(timeStr) {
  const [hours, minutes] = timeStr.split(':').map(Number)
  return hours * 60 + minutes
}

export const timeReportValidate = (values) => {
  const errors = {}
  const shiftsByDate = new Map() // Map<date, Array<{ start: number, end: number, index: number }>>
  const requiredFields = ['task_description']

  requiredFields.forEach((field) => {
    if (isEmpty(values[field])) {
      errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
    }
  })

  const rowErrors = []
  values.dateTimeRows.forEach((row, index) => {
    const error = {}
    const dateKey = format(new Date(row.date), 'yyyy-MM-dd')

    const start = toMinutes(row.startTime)
    const end = toMinutes(row.endTime)

    // Check if start time is before end time
    if (row.startTime && row.endTime && row.startTime >= row.endTime) {
      error.startTime = i18next.t('ws_journal.warn1') // Start time must be earlier than end time
    }
    if (row.startTime && row.endTime && row.endTime <= row.startTime) {
      error.endTime = i18next.t('ws_journal.warn2') // End time must be later than start time
    }

    // Check overlap with previous shifts on the same date
    if (!shiftsByDate.has(dateKey)) {
      shiftsByDate.set(dateKey, [])
    }

    const existingShifts = shiftsByDate.get(dateKey)
    for (const shift of existingShifts) {
      const overlaps = start < shift.end && end > shift.start
      if (overlaps) {
        error.startTime = i18next.t('ws_journal.warn4')
        error.endTime = i18next.t('ws_journal.warn4')
        break
      }
    }

    // Add current shift to tracking list
    existingShifts.push({ start, end, index })

    if (!isEmpty(error)) {
      rowErrors[index] = error
    }
  })

  if (!isEmpty(rowErrors)) {
    errors.dateTimeRows = rowErrors
  }

  return { values, errors }
}

export const actualTimeValidate = (
  values,
  workshift_start_time,
  workshift_endtime
) => {
  const errors = {}
  const requiredFields = ['note']

  const startTime = formatTime(values.startTime)
  const endTime = formatTime(values.endTime)

  if (
    startTime !== formatTime(workshift_start_time) ||
    endTime !== formatTime(workshift_endtime)
  ) {
    requiredFields.forEach((field) => {
      if (isEmpty(values[field])) {
        errors[field] = i18next.t('validation.pako') // 'Kenttä on pakollinen'
      }
    })
  }

  // Check if start time is before end time

  if (startTime && endTime && startTime >= endTime) {
    errors.startTime = i18next.t('workshift.valid1') // Start time must be earlier than end time
  }
  if (startTime && endTime && endTime <= startTime) {
    errors.endTime = i18next.t('workshift.valid2') // End time must be later than start time
  }

  // console.log(errors)

  return { values, errors }
}
